import React from 'react';
import ceoImage from '../assets/images/ceo.png';

const CEOSection = () => {
    return (
        <section className="py-24 bg-white">
            <div className="container mx-auto px-6 md:px-12">
                <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-center md:items-start">
                    {/* Left Column: Photo and Identity */}
                    <div className="w-full max-w-[240px] md:w-1/4 lg:w-1/5 flex flex-col items-center">
                        <div className="w-full bg-[#f3f4f6] rounded shadow-sm overflow-hidden p-2">
                            <div className="aspect-[4/4] relative">
                                <img
                                    src={ceoImage}
                                    alt="Mr. Vijay Kumar"
                                    className="absolute inset-0 w-full h-full object-cover grayscale-[0.2]"
                                />
                            </div>
                        </div>
                        <div className="mt-4 md:mt-6 text-center">
                            <h4 className="text-[#1a365d] text-lg md:text-xl font-medium tracking-tight">Mr. Vijay Kumar</h4>
                            <p className="text-[#1a365d] text-sm md:text-[15px] mt-1">CEO and Director</p>
                        </div>
                    </div>

                    {/* Right Column: Content */}
                    <div className="w-full md:w-3/4 lg:w-4/5 text-center md:text-left">
                        <h2 className="text-[#f39c12] text-2xl md:text-3xl font-bold mb-8 md:mb-10 uppercase tracking-[0.1em] md:tracking-[0.15em]">
                            CEO AND DIRECTOR
                        </h2>

                        <div className="text-gray-700 leading-relaxed space-y-6 md:space-y-8 text-sm md:text-[15.5px] font-serif italic max-w-5xl">
                            <p>
                                An Engineering Graduate, Mr. Vijay has over two and half decades of
                                experience in the leading software companies across India. His years of
                                international working experience across various geographies gave him a clear
                                business acumen and an eye for detail.
                            </p>
                            <p>
                                His exceptional knowledge, vision for the future, and strategic insights are what
                                clearly define him. He held a key role in handling critical assignments over the
                                years which gave him the right exposure to various technologies.
                            </p>
                            <p>
                                His extensive knowledge coupled with meticulous execution and development
                                capabilities gives him a thrust in understanding the businesses, client
                                requirements, and in planning a goal-driven approach.
                            </p>
                            <p>
                                His skills are multi-disciplinary and cross-sectoral. A very industrious person he
                                has worked across different domains - Banking, Trading, Retail, Insurance are a
                                few among others.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CEOSection;
